export const getTenantTransactions = (tenantId, startDate="", endDate="") => {
    const query = `
        query{
            tenantTransactions(
                tenantId: ${JSON.stringify(tenantId)}, 
                startDate: ${ !startDate? JSON.stringify("") : JSON.stringify(startDate.format("YYYY-MM-DD"))}, 
                endDate: ${ !endDate? JSON.stringify("") : JSON.stringify(endDate.format("YYYY-MM-DD"))}
            ){
                id
                date
                itemType
                amount
                description
                moneyPaid
                moneyDue
                endOfDayBalance
                message
            }
        }
    `;
    return query;
}